import React from "react";
import styles from './CardLayout.module.css';

interface CardProps {
  title?: string;
  children: React.ReactNode;
}

const CardLayout: React.FC<CardProps> = ({ title, children }) => {
  return (
    <div className={styles.container}>
      {/* Header */}
      {title && (
        <div className={styles.header}>
          <div className={styles.title}>
            {title}
          </div>
        </div>
      )}

      {/* Conteúdo */}
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default CardLayout;
